export const CLINIC_FEATURE_MODULES = [
    {
        id: 'appointments',
        featureKey: 'isAppointments',
        label: 'Appointments',
        description: 'View the clinic schedule and manage appointment confirmations.',
        icon: 'bi-calendar-event',
        theme: 'purple',
        to: '/appointments',
        group: 'Scheduling',
    },
    {
        id: 'booking',
        featureKey: 'booking',
        label: 'Web Bookings',
        description: 'Manage online appointment requests from patients.',
        icon: 'bi-calendar-check',
        theme: 'cyan',
        to: '/web-bookings',
        group: 'Scheduling',
    },
    {
        id: 'messages',
        featureKey: 'twoWayText',
        label: 'Messages',
        description: 'Two-way texting with patients.',
        icon: 'bi-chat-left-text',
        theme: 'success',
        to: '/messages',
        group: 'Communication',
    },
    {
        id: 'surveys',
        featureKey: 'survey',
        label: 'Surveys',
        description: 'Create and send patient surveys.',
        icon: 'bi-clipboard-check',
        theme: 'teal',
        to: '/surveys',
        group: 'Communication',
    },
    {
        id: 'survey-reminders',
        featureKey: 'isSurvey',
        label: 'Survey Reminders',
        description: 'Send reminders to complete patient surveys.',
        icon: 'bi-clipboard-check',
        theme: 'teal',
        to: '/surveys',
        group: 'Communication',
    },
    {
        id: 'articles',
        featureKey: 'isArticle',
        label: 'Articles',
        description: 'Create and send patient education articles.',
        icon: 'bi-file-text',
        theme: 'orange',
        to: '/articles',
        group: 'Communication',
    },
    {
        id: 'optical-dispensary',
        featureKey: 'isOpticalDispensary',
        label: 'Optical Dispensary',
        description: 'Manage pickups, contact lens reorder requests, and CL brands.',
        icon: 'bi-eyeglasses',
        theme: 'violet',
        to: '/optical-dispensary/pickups',
        group: 'Scheduling',
    },
    {
        id: 'invalid-details-summary',
        featureKey: 'isInvalidSummary',
        label: 'Invalid Details Summary',
        description: 'Receive digest emails for invalid patient contact details.',
        icon: 'bi-exclamation-octagon',
        theme: 'danger',
        to: '/invalid-details',
        group: 'Engagement',
    },
    {
        id: 'newsletter-email',
        featureKey: 'newsletterEmail',
        label: 'Email Newsletter',
        description: 'Send email newsletters to patients.',
        icon: 'bi-envelope-paper',
        theme: 'pink',
        to: '/newsletter/email-newsletter',
        group: 'Communication',
    },
    {
        id: 'newsletter-sms',
        featureKey: 'newsletterSms',
        label: 'SMS Newsletter',
        description: 'Send SMS newsletters to patients.',
        icon: 'bi-chat-text',
        theme: 'pink',
        to: '/newsletter/sms-newsletter',
        group: 'Communication',
    },
    {
        id: 'blast-email',
        featureKey: 'blastEmail',
        label: 'Email Blast',
        description: 'Send marketing emails to patient lists.',
        icon: 'bi-send',
        theme: 'danger',
        to: '/blast/email',
        group: 'Communication',
    },
    {
        id: 'blast-sms',
        featureKey: 'blastSms',
        label: 'SMS Blast',
        description: 'Send marketing text messages to patient lists.',
        icon: 'bi-chat-dots',
        theme: 'danger',
        to: '/blast/sms',
        group: 'Communication',
    },
    {
        id: 'blast-call',
        featureKey: 'blastCall',
        label: 'Call Blast',
        description: 'Send marketing phone calls to patient lists.',
        icon: 'bi-telephone-outbound',
        theme: 'danger',
        to: '/blast/call',
        group: 'Communication',
    },
    {
        id: 'reputation',
        featureKey: 'reputation',
        label: 'Reputation',
        description: 'Monitor and manage online reputation.',
        icon: 'bi-star',
        theme: 'warning',
        to: '/reputation',
        group: 'Engagement',
    },
    {
        id: 'recalls',
        featureKey: 'recall',
        label: 'Recalls',
        description: 'Upload recall files and track processing.',
        icon: 'bi-person-check',
        theme: 'orange',
        to: '/recalls',
        group: 'Engagement',
    },
];
